import React from 'react'
import { SearchResultPageProps } from 'src/pages/SearchPage/SearchResultPage/index'
import HasSearchResult from 'src/pages/SearchPage/SearchResultPage/_components/HasSearchResult'
import SearchRecommendBrand from 'src/pages/SearchPage/SearchResultPage/_components/SearchRecommendBrand'
import { Divider } from 'src/components/common/Divider'
import styled, { css } from 'styled-components'
import { Container } from 'src/components/common/Container'
import { Typography } from 'src/components/common/Typography'
import { Noto_body1_r16 } from 'src/styles/fonts/NotoSansKrFonts'

const SearchResultPageView = (props: SearchResultPageProps) => {
  const { searchResultList, isSearchResultSuccess } = props
  const isNotResult = searchResultList?.length === 0
  return (
    <Container $option="flex_column" $style={S.SearchResultPageContainer}>
      {isSearchResultSuccess && isNotResult ? (
        <S.SearchIsNotResultContainer $option="flex_column">
          <S.SearchIsNotResultPrimaryText $fontStyle={Noto_body1_r16} $color="var(--black-50)">
            일치하는 결과가 없습니다.
          </S.SearchIsNotResultPrimaryText>
        </S.SearchIsNotResultContainer>
      ) : (
        <React.Fragment>
          <SearchRecommendBrand {...props} />
          <Divider />
          <HasSearchResult {...props} />
        </React.Fragment>
      )}
    </Container>
  )
}
export default SearchResultPageView

const S = {
  SearchResultPageContainer: css`
    flex: 1;
  `,
  SearchIsNotResultContainer: styled(Container)`
    justify-content: center;
    flex: 1;
    min-height: 200px;
  `,
  SearchIsNotResultPrimaryText: styled(Typography)`
    text-align: center;
    margin: 0 auto;
  `,
}
